import { PageHeader } from '@/components/layout/PageHeader';
import { PatientDownloadScreen } from '@/components/features/download/PatientDownloadScreen';
import { useActivities } from '@/hooks/useActivities';

export function PatientRawDownload() {
  const { activities, isLoading } = useActivities({ isCurrentPatient: true });

  return (
    <div>
      <PageHeader
        title="Download Raw Activities"
        description="Filter and download your raw activity data"
      />

      <PatientDownloadScreen
        activities={activities}
        isLoading={isLoading}
        mode="raw"
      />
    </div>
  );
}
